const prefix = 'active-versions-drilldown-page';

export const i18n = {
    productLabel: {
        id: `${prefix}.productLabel`,
        defaultMessage: 'Product',
    },
    versionLabel: {
        id: `${prefix}.versionLabel`,
        defaultMessage: 'Version',
    },
    totalSignInsLabel: {
        id: `${prefix}.totalSignInsLabel`,
        defaultMessage: 'Total Sign-Ins',
    },
    uniqueUsersLabel: {
        id: `${prefix}.uniqueUsersLabel`,
        defaultMessage: 'Unique Users',
    },
    signInsHeading: {
        id: `${prefix}.signInsHeading`,
        defaultMessage: 'Sign-Ins',
    },
    subscriptionName: {
        id: `${prefix}.subscriptionName`,
        defaultMessage: 'Instance',
    },
    userLogin: {
        id: `${prefix}.userLogin`,
        defaultMessage: 'User',
    },
    totalSignInsColumn: {
        id: `${prefix}.totalSignInsColumn`,
        defaultMessage: 'Total Sign-Ins',
    },
    latestAttempt: {
        id: `${prefix}.latestAttempt`,
        defaultMessage: 'Latest Attempt',
    },
    noResultsTitle: {
        id: `${prefix}.noResultsTitle`,
        defaultMessage: 'No sign-in records',
    },
    noResultsMessage: {
        id: `${prefix}.noResultsMessage`,
        defaultMessage: 'There are no sign-in records for this product and version.',
    },
} as const;
